$(document).on('submit', '.register-form', function(e){
  e.preventDefault();
  var headers = {
    'X-CSRF-TOKEN': $('input[name=_token]').val()
  }

  $('.error-message').remove();
  $('#register-alert').html('');

  var data = {
    fname: $(".register-form input[name=fname]").val(),
    lname: $(".register-form input[name=lname]").val(),
    gender: $(".register-form input[name=gender]").val(),
    email: $(".register-form input[name=email]").val(),
    terms: $(".register-form input[name=terms]:checked").val(),
    newsletter: $(".register-form input[name=newsletter]:checked").val(),
    password: $(".register-form input[name=password]").val(),
    password_confirmation: $(".register-form input[name=password_confirmation]").val(),
  }
  $.ajax({
    url: $(this).attr('action'),
    data: data,
    dataType: 'json',
    type: 'post',
    headers: headers,
    success: function(data){
      if (data.code == 'error') {
        $.each(data.fields, function(key, value){
          const error = `<span class="text-danger error-message">${value}</span>`;
          console.log(key);
          if (key != 'terms') {
            $('.register-form input[name='+key+']').after(error)
          }else{
            $('.register-form label[for='+key+'_check]').after(error)
          }
        })
      }else{
        $('#register-alert').html(data.fields)
        setTimeout(function(){
          location.reload();
        }, 3000);
      }

    }
  })
});
